module.exports = __webpack_public_path__ + "static/5-after-B.d10aca69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/full-size/5-after-B.jpg
// module id = 441
// module chunks = 221374088121123